"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var VIcon_vue_1 = __importDefault(require("./VIcon.vue"));
exports.default = vue_1.default.extend({
    name: "v-view-link",
    components: {
        VIcon: VIcon_vue_1.default
    },
    props: {
        view: {
            type: Object,
            required: true
        },
        displayTooltip: {
            type: Boolean,
            default: true
        },
        displayTitle: {
            type: Boolean,
            default: true
        },
        displayIcon: {
            type: Boolean,
            default: true
        },
        dismissTooltips: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onClick: function () {
            if (this.dismissTooltips) {
                $(".tooltip").tooltip("dispose");
            }
        }
    }
});
